import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'login',
		meta: {
			title: '登录',
		},
		component: () => import('../views/LoginView.vue')
	},
	{
		path: '/Home',
		name: 'home',
		component: () => import('../views/HomeView.vue'),
		children: [{
			path: '/Index',
			name: 'Index',
			meta: {
				title: '数据统计',
			},
			component: () => import('../views/IndexView.vue'),
		}, {
			path: '/WarehouseManage/WarehouseManage',
			name: 'WarehouseManage',
			meta: {
				title: '仓库管理',
			},
			component: () => import('../views/Warehouse/WarehouseManage.vue'),
		}, {
			path: '/WarehouseManage/WarehouseAreaManage',
			name: 'WarehouseAreaManage',
			meta: {
				title: '区域管理',
			},
			component: () => import('../views/Warehouse/WarehouseAreaManage.vue'),
		}, {
			path: '/WarehouseManage/WarehouseLocationManage',
			name: 'WarehouseLocationManage',
			meta: {
				title: '货位管理',
			},
			component: () => import('../views/Warehouse/WarehouseLocationManage.vue'),
		}, {
			path: '/WarehouseManage/ShelvesManage',
			name: 'ShelvesManage',
			meta: {
				title: '货柜管理',
			},
			component: () => import('../views/Warehouse/ShelvesManage.vue'),
		}, {
			path: '/GoodManage/Category',
			name: 'Category',
			meta: {
				title: '商品分类',
			},
			component: () => import('../views/GoodManage/Category.vue'),
		}, {
			path: '/GoodManage/GoodManage',
			name: 'GoodManage',
			meta: {
				title: '商品管理',
			},
			component: () => import('../views/GoodManage/GoodManage.vue'),
		}, {
			path: '/RfidManage/RfidManage',
			name: 'RfidManage',
			meta: {
				title: 'RFID标签管理',
			},
			component: () => import('../views/RfidManage/RfidManage.vue'),
		}, {
			path: '/RfidManage/PdaManage',
			name: 'PdaManage',
			meta: {
				title: 'PDA管理',
			},
			component: () => import('../views/RfidManage/PdaManage.vue'),
		}, {
			path: '/WarehouseOperations/InWarehouseManage',
			name: 'InWarehouseManage',
			meta: {
				title: '入库管理',
			},
			component: () => import('../views/WarehouseOperations/InWarehouseManage.vue'),
		}, {
			path: '/WarehouseOperations/OutWarehouseManage',
			name: 'OutWarehouseManage',
			meta: {
				title: '出库管理',
			},
			component: () => import('../views/WarehouseOperations/OutWarehouseManage.vue'),
		}, {
			path: '/WarehouseOperations/InventoryManage',
			name: 'InventoryManage',
			meta: {
				title: '盘点管理',
			},
			component: () => import('../views/WarehouseOperations/InventoryManage.vue'),
		}, {
			path: '/WarehouseOperations/AllocationManage',
			name: 'AllocationManage',
			meta: {
				title: '调拨管理',
			},
			component: () => import('../views/WarehouseOperations/AllocationManage.vue'),
		}, {
			path: '/WarehouseOperations/RelocationManage',
			name: 'RelocationManage',
			meta: {
				title: '移库管理',
			},
			component: () => import('../views/WarehouseOperations/RelocationManage.vue'),
		}, {
			path: '/ReportManager/InventoryDetails',
			name: 'InventoryDetails',
			meta: {
				title: '库存明细',
			},
			component: () => import('../views/ReportManager/InventoryDetails.vue'),
		}, {
			path: '/ReportManager/InventoryLedger',
			name: 'InventoryLedger',
			meta: {
				title: '库存台账',
			},
			component: () => import('../views/ReportManager/InventoryLedger.vue'),
		}, {
			path: '/ReportManager/InWarehouseDetails',
			name: 'InWarehouseDetails',
			meta: {
				title: '入库明细',
			},
			component: () => import('../views/ReportManager/InWarehouseDetails.vue'),
		}, {
			path: '/ReportManager/OutWarehouseDetails',
			name: 'OutWarehouseDetails',
			meta: {
				title: '出库明细',
			},
			component: () => import('../views/ReportManager/OutWarehouseDetails.vue'),
		}, {
			path: '/ReportManager/TraceabilityReport',
			name: 'TraceabilityReport',
			meta: {
				title: '溯源报表',
			},
			component: () => import('../views/ReportManager/TraceabilityReport.vue'),
		}, {
			path: '/TypeManage/StorageAreaType',
			name: 'StorageAreaType',
			meta: {
				title: '区域类型',
			},
			component: () => import('../views/TypeManage/StorageAreaType.vue'),
		}, {
			path: '/TypeManage/LocationType',
			name: 'LocationType',
			meta: {
				title: '货位类型',
			},
			component: () => import('../views/TypeManage/LocationType.vue'),
		}, {
			path: '/TypeManage/ReceiptType',
			name: 'ReceiptType',
			meta: {
				title: '入库类型',
			},
			component: () => import('../views/TypeManage/ReceiptType.vue'),
		}, {
			path: '/TypeManage/OutboundType',
			name: 'OutboundType',
			meta: {
				title: '出库类型',
			},
			component: () => import('../views/TypeManage/OutboundType.vue'),
		}, {
			path: '/SystemConfig/SystemMenuList',
			name: 'SystemMenuList',
			meta: {
				title: '系统菜单管理',
			},
			component: () => import('../views/SystemManage/SystemMenuList.vue'),
		}, {
			path: '/SystemConfig/UserAccessControl',
			name: 'UserAccessControl',
			meta: {
				title: '权限管理',
			},
			component: () => import('../views/SystemManage/UserAccessControl.vue'),
		}, {
			path: '/SystemConfig/StaffManage',
			name: 'StaffManage',
			meta: {
				title: '员工管理',
			},
			component: () => import('../views/SystemManage/StaffManage.vue'),
		}, {
			path: '/SystemConfig/DepartmentManege',
			name: 'DepartmentManege',
			meta: {
				title: '部门管理',
			},
			component: () => import('../views/SystemManage/DepartmentManege.vue'),
		}, {
			path: '/SystemConfig/PersonnelManage',
			name: 'PersonnelManage',
			meta: {
				title: '人员管理',
			},
			component: () => import('../views/SystemManage/PersonnelManage.vue'),
		}, {
			path: '/SystemConfig/WarehouseAuth',
			name: 'WarehouseAuth',
			meta: {
				title: '仓库权限',
			},
			component: () => import('../views/SystemManage/WarehouseAuth.vue'),
		}, {
			path: '/SystemConfig/VersionControl',
			name: 'VersionControl',
			meta: {
				title: '应用管理',
			},
			component: () => import('../views/SystemManage/VersionControl.vue'),
		}, {
			path: '/SystemConfig/SystemConfig',
			name: 'SystemConfig',
			meta: {
				title: '系统配置',
			},
			component: () => import('../views/SystemManage/SystemConfig.vue'),
		}],
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = "卡洛RFID智能盘点系统";
	}
	next();
})

export default router